import React, { useState, useEffect } from "react";
import {
    Box, TextField, Checkbox, FormControlLabel, Typography, Grid, List, ListItem, ListItemIcon,
    IconButton, Button, FormGroup, Tabs, Tab, FormControl, InputLabel, Select, MenuItem, Stack,
} from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { MODULE_LIST_DATA, NEW_MODULE_LIST_DATA, Permission_Access } from "../../../../Utility/Constants";
import { ImagePaths } from "../../../../Utility/ImagePaths";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import RestAPIService from "../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../Utility/API/Serviceurls";
import ToastMsg from "../../../../Components/ToastMsg/ToastMsg";
import { localGetItem } from "../../../../Utility/Services/CacheProviderService";
import { Colors } from "../../../../Styles/Colors";
import Loader from "../../../../Components/Loader";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import CommonValidation from "../../../../Components/CommonFunctions/CommonValidation";


const AddGlobalRole = (props) => {
    const { id } = useParams();
    const history = useHistory();
    const location = useLocation();

    const passedState = location.state || {};
    const module_access = JSON.parse(JSON.stringify(NEW_MODULE_LIST_DATA));
    const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    const [isloader, setisloader] = useState(false);
    const [role, setRole] = useState({
        role_code: passedState.role_code || "",
        role_name: passedState.role_name || "",
        edit_id: passedState.edit_id || null,
        module_access: module_access,
    });
    const isFromPharmacy = props?.fromPharmacy ? props?.fromPharmacy : false;
    const [moduleList, setModuleList] = useState(localGetItem("isNewBilling") === 'true' ? JSON.parse(JSON.stringify(NEW_MODULE_LIST_DATA)) : JSON.parse(JSON.stringify(MODULE_LIST_DATA)),);
    const [selectedModule, setSelectedModule] = useState(null);
    const [userModuleData, setUserModuleData] = useState([]);
    const [moduleAndRoleList, setModuleAndRoleList] = useState([]);
    const [shouldRunSubLocation, setShouldRunSubLocation] = useState(false);
    const [tabDetail, setTabDetail] = useState("one");
    const [isApprover, setIsApprover] = useState(false);
    const [cashCounterModuleList, setCashCounterModuleList] = useState([]);
    const [states, setStates] = useState({
        per_Access: structuredClone(Permission_Access)
    });


    const [message, setMessage] = useState({
        isErrorMsgText: "",
        successMsgText: "",
        isErrorMsg: false,
        successMsg: false,
    });

    useEffect(() => {
        getUserAccessModuleData()
        if (localGetItem('isNewBilling') === "true") {
            getCashCounterModules()
        }
    }, [])

    useEffect(() => {
        if (passedState?.edit_id) {
            handleEditDataFetch();
        }
    }, [passedState?.edit_id]);


    useEffect(() => {
        if (shouldRunSubLocation) {
            storeSubLocationCondition();
            setShouldRunSubLocation(false);
        }
    }, [moduleAndRoleList, shouldRunSubLocation]);

    const handleEditDataFetch = () => {
        try {
            RestAPIService.getAll(Serviceurls.GLB_ROLE_ACCESS_DATA + `?role_id=${passedState?.edit_id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const Data = response.data.data || {}
                        let access = JSON.parse(Data?.permission_access || '{}');

                        // Update role state with the fetched data - clean up collapsed structure
                        const cleanedModules = Data?.modules?.map(module => {
                            // Check if this module has the collapsed structure (both object and array)
                            const hasObjectModuleAccess = module.module_access && typeof module.module_access === 'object' && module.module_access.data;
                            const hasArrayModuleAccess = module.module_access && Array.isArray(module.module_access) && module.module_access.length > 0;

                            // If it has both (collapsed structure), remove the object and keep only the array
                            if (hasObjectModuleAccess && hasArrayModuleAccess) {
                                // Create a clean module with only the array version
                                const cleanModule = { ...module };
                                // Remove the object version by deleting the property
                                delete cleanModule.module_access;
                                // Add back only the array version
                                cleanModule.module_access = module.module_access;
                                return cleanModule;
                            }
                            // If module has only object module_access, convert to array format
                            else if (hasObjectModuleAccess && !hasArrayModuleAccess) {
                                return {
                                    ...module,
                                    module_access: [module.module_access]
                                };
                            }
                            // If module has only array module_access, keep as is
                            else if (hasArrayModuleAccess && !hasObjectModuleAccess) {
                                return module;
                            }
                            // Otherwise return as is
                            return module;
                        }) || [];

                        setRole(prev => ({
                            ...prev,
                            module_access: cleanedModules
                        }));

                        // Update per_Access state
                        setStates(prev => ({
                            ...prev,
                            per_Access: access
                        }));

                        // Update moduleList with the fetched module data
                        if (Data?.modules && Array.isArray(Data.modules)) {
                            // Transform modules for display purposes only
                            const transformedFetchedModules = Data.modules.map(module => {
                                // Handle different module_access structures for display
                                let moduleData = [];
                                let moduleTitle = module.label || module.module_name || module.title;

                                // Check if module_access is an array (old structure)
                                if (Array.isArray(module.module_access) && module.module_access.length > 0) {
                                    moduleData = module.module_access[0].data || [];
                                }
                                // Check if module_access is an object (new structure)
                                else if (module.module_access && typeof module.module_access === 'object' && module.module_access.data) {
                                    moduleData = module.module_access.data || [];
                                }

                                return {
                                    ...module,
                                    data: moduleData,
                                    title: moduleTitle,
                                    department: module.department
                                };
                            });

                            // Merge with existing moduleList instead of replacing
                            setModuleList(prevModuleList => {
                                const mergedModules = [...prevModuleList];

                                // Update existing modules with fetched data
                                transformedFetchedModules.forEach(fetchedModule => {
                                    const existingIndex = mergedModules.findIndex(existing => {
                                        // Direct title/label match
                                        if (existing.title === fetchedModule.title || existing.label === fetchedModule.title) {
                                            return true;
                                        }
                                        // For Store Sub Location modules, match by department
                                        if (fetchedModule.title === "Store Sub Location" && existing.title === "Store Sub Location" &&
                                            existing.department === fetchedModule.department) {
                                            return true;
                                        }
                                        // For modules with departments, match by department
                                        if (existing.department === fetchedModule.department &&
                                            (existing.title === fetchedModule.title || existing.label === fetchedModule.title)) {
                                            return true;
                                        }
                                        return false;
                                    });

                                    if (existingIndex !== -1) {
                                        // Update existing module with fetched data
                                        mergedModules[existingIndex] = {
                                            ...mergedModules[existingIndex],
                                            ...fetchedModule,
                                            data: fetchedModule.data || mergedModules[existingIndex].data
                                        };
                                    } else {
                                        // Add new module if it doesn't exist
                                        mergedModules.push(fetchedModule);
                                    }
                                });

                                return mergedModules;
                            });

                            // Update moduleAndRoleList for the dropdown (keep all modules, not just fetched ones)
                            setModuleAndRoleList(prevList => {
                                const fetchedModuleNames = Data.modules.map(module => module.label || module.module_name);
                                const existingModules = prevList.filter(module => !fetchedModuleNames.includes(module.module_name));
                                const newModules = Data.modules.map(module => {
                                    // Extract department from module name for Store Sub Location modules
                                    let department = module.department;
                                    const moduleName = module.label || module.module_name;

                                    // If it's a Store Sub Location module and no department is provided, extract from name
                                    if ((module.moduels === "Store Sub Location" || module.module_type === "Store Sub Location") && !department) {
                                        // Extract department from module name patterns
                                        if (moduleName.includes("PH")) {
                                            department = "Pharmacy";
                                        } else if (moduleName.includes("LAB")) {
                                            department = "LAB";
                                        } else if (moduleName.includes("RAD")) {
                                            department = "Radiology";
                                        } else if (moduleName.includes("FO")) {
                                            department = "Front Office";
                                        } else {
                                            department = "LAB"; // Default fallback
                                        }
                                    }


                                    return {
                                        module_name: moduleName,
                                        module_id: module.module_id,
                                        module_type: module.moduels || module.module_type,
                                        moduels: module.moduels || module.module_type,
                                        department: department // Use extracted department
                                    };
                                });
                                return [...existingModules, ...newModules];
                            });
                        }

                    }
                }).catch(e => {
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }


    const getUserAccessModuleData = () => {
        setisloader(true)
        try {
            RestAPIService.getAll(Serviceurls.USER_ACCESS_GET_MODULES)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const Data = response.data.data || []
                        setUserModuleData(Data)
                        setisloader(false)
                    }
                }).catch(e => {
                    errorMessage(e?.response?.data?.message || e?.message)
                    setisloader(false)
                })
        } catch (e) {
            errorMessage(e.message)
            setisloader(false)
        }
    }

    const getCashCounterModules = () => {
        try {
            RestAPIService.getAll(Serviceurls.CASH_COUNTER_MODULES_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const Data = response.data.data || []
                        setCashCounterModuleList(Data)
                    }
                }).catch(e => {
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: msg,
        });
    };

    const successMessage = (msg) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: msg,
        });
    };

    const msgClose = () => {
        setMessage({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        });
    };

    const initializeModuleList = () => {
        try {
            const userData = JSON.parse(localGetItem("loggedInUserInfo"));
            const isNewBilling = localGetItem("isNewBilling") === "true";

            const moduleLayout = isNewBilling ? JSON.parse(JSON.stringify(NEW_MODULE_LIST_DATA)) : JSON.parse(JSON.stringify(MODULE_LIST_DATA));

            const branchId = JSON.parse(localGetItem("BranchId"));
            const modulesList = JSON.parse(localGetItem("ModulesList"));
            const logModuleList = modulesList?.find((item) => item?.branch_id === branchId);

            // Extract references
            const pharmaData = moduleLayout?.find((item) => item?.title === "Pharmacy");
            const labData = moduleLayout?.find((item) => item?.title === "Laboratory");
            const storeSubLocData = moduleLayout?.find((item) => item?.title === "Store Sub Location");
            const subLocData = moduleLayout?.find((item) => item?.title === "sub_location");
            const investigationData = moduleLayout?.find((item) => item?.title === "Investigation");

            // Filter out modules not needed
            let filteredModule = moduleLayout?.filter(
                (list) =>
                    list?.title !== "Pharmacy" &&
                    list?.title !== "Laboratory" &&
                    list?.title !== "Store Sub Location" &&
                    list?.title !== "sub_location"
            );

            // Update labels dynamically
            logModuleList?.data?.forEach((item) => {
                if (item?.moduels === "front_office") {
                    filteredModule[0]["title"] = item?.label;
                } else if (item?.moduels === "Radiology") {
                    const moduleIndex = filteredModule.findIndex((m) => m.module_type === "Radiology");
                    if (moduleIndex !== -1) filteredModule[moduleIndex]["title"] = item?.label;
                } else if (item?.moduels === "store_module") {
                    const moduleIndex = filteredModule.findIndex((m) => m.module_type === "store_module");
                    if (moduleIndex !== -1) filteredModule[moduleIndex]["title"] = item?.label;
                } else if (item?.moduels === "Investigation") {
                    const moduleIndex = filteredModule.findIndex((m) => m.module_type === "Investigation");
                    if (moduleIndex !== -1) filteredModule[moduleIndex]["title"] = item?.investigation_name;
                } else if (item?.moduels === "master_record_department") {
                    const moduleIndex = filteredModule.findIndex((m) => m.module_type === "master_record_department");
                    if (moduleIndex !== -1) filteredModule[moduleIndex]["title"] = item?.label;
                } else if (item?.moduels === "sub_location") {
                    const moduleIndex = filteredModule.findIndex((m) => m.module_type === "sub_location");
                    if (moduleIndex !== -1) filteredModule[moduleIndex]["title"] = item?.label;
                }
            });

            // Add multiple labs and pharmacies
            const labList = userData?.laboratory_data;
            const pharmacyList = userData?.pharmacy_data;

            labList?.forEach((item) => {
                const labClone = JSON.parse(JSON.stringify(labData));
                labClone.title = item?.module_name;
                labClone.department = item?.module; // Add department for isolation
                labClone.uniqueId = `${item?.module_name}_${item?.module}`; // Add unique ID
                filteredModule.push(labClone);
            });

            pharmacyList?.forEach((item) => {
                const pharmaClone = JSON.parse(JSON.stringify(pharmaData));
                pharmaClone.title = item?.module_name;
                pharmaClone.department = item?.module; // Add department for isolation
                pharmaClone.uniqueId = `${item?.module_name}_${item?.module}`; // Add unique ID
                filteredModule.push(pharmaClone);
            });

            logModuleList?.data
                ?.filter((item) => item?.moduels === "sub_location" && item?.module)
                ?.forEach((item) => {
                    const storeClone = JSON.parse(JSON.stringify(storeSubLocData));
                    storeClone.title = item?.label;
                    storeClone.department = item?.module;
                    // Ensure each module has a unique identifier
                    storeClone.uniqueId = `${item?.label}_${item?.module}`;
                    filteredModule.push(storeClone);
                });

            logModuleList?.data
                ?.filter((item) => {
                    // Allow ALL sub_location modules, even if they don't have departments
                    return item?.moduels === "sub_location";
                })
                ?.forEach((item) => {
                    const subClone = JSON.parse(JSON.stringify(subLocData));
                    subClone.title = item?.label;
                    subClone.department = item?.module || null; // Allow null departments
                    // For uniqueId, use a different approach when department is null
                    subClone.uniqueId = item?.module ? `${item?.label}_${item?.module}` : `${item?.label}_no_dept`;
                    filteredModule.push(subClone);
                });

            logModuleList?.data
                ?.filter((item) => item?.moduels === "Investigation" && item?.moduels)
                ?.forEach((item) => {
                    const invClone = JSON.parse(JSON.stringify(investigationData));
                    invClone.title = item?.module;
                    invClone.department = item?.module;
                    filteredModule.push(invClone);
                });

            return filteredModule;
        } catch (e) {
            errorMessage(e?.message);
            return [];
        }
    };

    useEffect(() => {
        const filteredModule = initializeModuleList();
        if (filteredModule.length > 0) {
            setModuleList(filteredModule);
        }
    }, []);

    const onChangeHandler = (e) => {
        if (e.target.name === 'selectedModule') {
            setSelectedModule(e.target.value);
        }
    }

    const findModuleBySelectedModule = (selectedModuleValue) => {
        if (!selectedModuleValue) return null;

        // Check if value is in composite format (module_name::moduels or module_name::moduels::id)
        if (selectedModuleValue.includes("::")) {
            const parts = selectedModuleValue.split("::");
            const moduleName = parts[0];
            const moduleType = parts[1];
            
            // Find module by name, type, and optionally department
            let foundModule = moduleList.find(item => {
                const nameMatches = (item.title === moduleName) || 
                                   (item.label === moduleName) || 
                                   (item.module_name === moduleName);
                const typeMatches = (item.module_type === moduleType) || 
                                   (item.moduels === moduleType);
                
                return nameMatches && typeMatches;
            });
            
            if (foundModule) {
                return foundModule;
            }
            
            // Try with department if provided
            if (parts.length > 2 && parts[2]) {
                foundModule = moduleList.find(item => {
                    const nameMatches = (item.title === moduleName) || 
                                       (item.label === moduleName) || 
                                       (item.module_name === moduleName);
                    const typeMatches = (item.module_type === moduleType) || 
                                       (item.moduels === moduleType);
                    const deptMatches = item.department === parts[2];
                    
                    return nameMatches && typeMatches && deptMatches;
                });
                
                if (foundModule) {
                    return foundModule;
                }
            }
        }

        // First try direct match with various possible field names
        let foundModule = moduleList.find(item =>
            (item.title === selectedModuleValue) ||
            (item.label === selectedModuleValue) ||
            (item.module_name === selectedModuleValue) ||
            (item.title + " (" + item.department + ")" === selectedModuleValue) ||
            (item.label + " (" + item.department + ")" === selectedModuleValue)
        );
        if (foundModule) {
            return foundModule;
        }

        // Try matching by uniqueId if available
        if (selectedModuleValue.includes("_")) {
            foundModule = moduleList.find(item =>
                item.uniqueId === selectedModuleValue
            );
            if (foundModule) {
                return foundModule;
            }
        }

        // Handle Store Sub Location with department matching
        if (selectedModuleValue.includes("Store Sub Location")) {
            // Extract department from the selected module name
            const departmentMatch = selectedModuleValue.match(/\(([^)]+)\)/);
            if (departmentMatch) {
                const department = departmentMatch[1];
                foundModule = moduleList.find(item =>
                    (item.title === "Store Sub Location" || item.label === "Store Sub Location") &&
                    item.department === department
                );
                if (foundModule) {
                    return foundModule;
                }
            }
        }

        // Handle other modules with department matching (like sub_location)
        if (selectedModuleValue.includes("(") && selectedModuleValue.includes(")")) {
            const departmentMatch = selectedModuleValue.match(/\(([^)]+)\)/);
            if (departmentMatch) {
                const department = departmentMatch[1];
                const baseTitle = selectedModuleValue.split(" (")[0];
                foundModule = moduleList.find(item =>
                    (item.title === baseTitle || item.label === baseTitle) &&
                    item.department === department
                );
                if (foundModule) return foundModule;
            }
        }

        // If not found, try to find by module_type or other matching logic
        // This handles cases where module_name from API doesn't match title from constants
        const moduleMapping = {
            'Store': 'store_module',
            'Front Office': 'front_office',
            'Laboratory': 'Laboratory',
            'Pharmacy': 'Pharmacy',
            'Radiology': 'Radiology',
            'Investigation': 'Investigation',
            'MRD': 'master_record_department',
            'Sub Location': 'sub_location'
        };

        const mappedTitle = moduleMapping[selectedModuleValue];
        if (mappedTitle) {
            foundModule = moduleList.find(item =>
                item.title === mappedTitle ||
                item.label === mappedTitle ||
                item.module_type === mappedTitle ||
                item.moduels === mappedTitle
            );
        }

        return foundModule;
    }


    const handleRoleDetailsChange = (e) => {
        const { name, value } = e.target;
        setRole({ ...role, [name]: value });
    };

    // Helper function to clean module names by removing department suffixes
    const cleanModuleName = (moduleName, moduleType) => {
        if (!moduleName) return moduleName;

        // Only remove department suffix for Store Sub Location and sub_location modules
        // that actually have departments (not null/undefined)
        if ((moduleType === "Store Sub Location" || moduleType === "sub_location") &&
            moduleName.includes("(") && moduleName.includes(")") &&
            !moduleName.includes("(null)") && !moduleName.includes("(undefined)")) {
            // Remove department suffix like " (Pharmacy)", " (LAB)", etc.
            const cleaned = moduleName.replace(/\s*\([^)]+\)$/, '');
            return cleaned;
        }

        // For other modules, return as is
        return moduleName;
    };

    const handleSave = () => {
        const { role_name } = role;
        let perAccess = JSON.stringify(states?.per_Access);
        const apiPayload = {
            id: passedState?.edit_id || null,
            role_name,
            permission_access: perAccess,
            modules: moduleAndRoleList.map((module) => {
                const matched = moduleList.find(m => {
                    // Direct title/label/module_name match
                    if (m.title === module.module_name || m.label === module.module_name || m.module_name === module.module_name) {
                        return true;
                    }

                    // For Store Sub Location modules, match by department
                    if (m.title === "Store Sub Location" && m.department === module.module_name) {
                        return true;
                    }

                    // For Store Sub Location modules where title is the module name, match by title
                    if (m.title === module.module_name && m.department) {
                        return true;
                    }

                    // For other modules with departments, match by department
                    if (m.department === module.module_name) {
                        return true;
                    }

                    // Handle department suffix matching (e.g., "LOCATION (LAB)" -> "LAB")
                    if (module.module_name.includes("(") && module.module_name.includes(")")) {
                        const departmentMatch = module.module_name.match(/\(([^)]+)\)/);
                        if (departmentMatch) {
                            const department = departmentMatch[1];
                            // Match by department
                            if (m.department === department) {
                                return true;
                            }
                            // Match by title + department
                            if (m.title === module.module_name.split(" (")[0] && m.department === department) {
                                return true;
                            }
                        }
                    }

                    return false;
                });


                const currentModuleData = matched?.data || [];
                const cleanedModuleName = cleanModuleName(module.module_name, matched?.moduels || matched?.module_type);

                // Always include module_access structure, even if empty
                // This ensures Store Sub Location and other modules have proper structure
                const moduleAccess = [{
                    title: cleanedModuleName, // Use cleaned name without department suffix
                    module_id: module?.id || module?.module_id || null,
                    role_module_id: passedState?.edit_id || null,
                    module_type: matched?.moduels || matched?.module_type || module?.moduels,
                    data: currentModuleData // This can be empty array, that's fine
                }];

                return {
                    module_id: module?.id || module?.module_id || null,
                    module_name: cleanedModuleName, // Use cleaned name without department suffix
                    modules: matched?.moduels || matched?.module_type || module?.moduels,
                    module_access: moduleAccess,
                };
            }),
        };

        try {
            setisloader(true)
            RestAPIService.create(apiPayload, Serviceurls.GLB_ROLE_MASTER)
                .then((response) => {
                    if (response?.data?.status === "success") {
                        successMessage(response?.data?.message);
                        setisloader(false)
                        history.push("/Settings/UserAccess/UserSettings/GlobalRoleMaster");
                    }
                })
                .catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message);
                    }
                    setisloader(false)
                });
        } catch (error) {
            errorMessage(error.message);
            setisloader(false)
        }
    };

    const disableCondition = (item) => {

        const isStoreSubLocation = (item?.itemModule === "Store Sub Location" || item?.module === "Store Sub Location" || item?.moduels === "Store Sub Location");
        const department = item?.department;

        if (isStoreSubLocation && department === "Front Office") {
            const isDisabled = !moduleAndRoleList?.some((list) =>
                list?.moduels === "front_office" ||
                list?.module_type === "front_office" ||
                list?.modules === "front_office"
            );
            return isDisabled;
        } else if (isStoreSubLocation && department === "Pharmacy") {
            const isDisabled = !moduleAndRoleList?.some((list) =>
                list?.moduels === "Pharmacy" ||
                list?.module_type === "Pharmacy" ||
                list?.modules === "Pharmacy"
            );
            return isDisabled;
        } else if (isStoreSubLocation && department === "Radiology") {
            const isDisabled = !moduleAndRoleList?.some((list) =>
                list?.moduels === "Radiology" ||
                list?.module_type === "Radiology" ||
                list?.modules === "Radiology"
            );
            return isDisabled;
        } else if (isStoreSubLocation && department === "LAB") {
            const isDisabled = !moduleAndRoleList?.some((list) =>
                list?.moduels === "Laboratory" ||
                list?.module_type === "Laboratory" ||
                list?.modules === "Laboratory"
            );
            return isDisabled;
        } else if (isStoreSubLocation && department) {
            const parentModuleType = department === "Front Office" ? "front_office" :
                department === "Pharmacy" ? "Pharmacy" :
                    department === "Radiology" ? "Radiology" :
                        department === "LAB" ? "Laboratory" : null;
            const isDisabled = parentModuleType ? !moduleAndRoleList?.some((list) =>
                list?.moduels === parentModuleType ||
                list?.module_type === parentModuleType ||
                list?.modules === parentModuleType
            ) : false;
            return isDisabled;
        } else {
            return false;
        }
    };

    const storeSubLocationCondition = () => {
        let selectedList = [...moduleAndRoleList];

        if (moduleAndRoleList?.every((list) => list?.moduels !== "front_office")) {
            selectedList = selectedList.filter(
                (el) => !(el?.moduels === "Store Sub Location" && el?.department === "Front Office")
            );
        }

        if (moduleAndRoleList?.every((list) => list?.moduels !== "Laboratory")) {
            selectedList = selectedList.filter(
                (el) => !(el?.moduels === "Store Sub Location" && el?.department === "LAB")
            );
        }

        if (moduleAndRoleList?.every((list) => list?.moduels !== "Pharmacy")) {
            selectedList = selectedList.filter(
                (el) => !(el?.moduels === "Store Sub Location" && el?.department === "Pharmacy")
            );
        }

        if (moduleAndRoleList?.every((list) => list?.moduels !== "Radiology")) {
            selectedList = selectedList.filter(
                (el) => !(el?.moduels === "Store Sub Location" && el?.department === "Radiology")
            );
        }

        setModuleAndRoleList(selectedList);
    };

    const onChangeHandleCheck = (e) => {
        const { name, checked } = e.target;

        setModuleList((prevModuleList) => {
            return prevModuleList.map((user) => {
                const foundModule = findModuleBySelectedModule(selectedModule);
                if (!foundModule) return user;

                // Use uniqueId for proper isolation of duplicate modules
                if (foundModule.uniqueId && user.uniqueId) {
                    if (user.uniqueId !== foundModule.uniqueId) return user;
                }
                // Fallback to department matching for modules without uniqueId
                else if (foundModule.department && user.department) {
                    if ((user.title !== foundModule.title && user.label !== foundModule.label) || user.department !== foundModule.department) return user;
                }
                // Final fallback to title and module_type matching - ensures proper isolation
                else {
                    // REQUIRED: Must have exact match on title/label AND module_type
                    const userMatch = user.title || user.label;
                    const foundMatch = foundModule.title || foundModule.label;
                    const userModuleType = user.module_type || user.moduels;
                    const foundModuleType = foundModule.module_type || foundModule.moduels;

                    if (userMatch !== foundMatch || userModuleType !== foundModuleType) return user;
                }

                const updatedData = user.data.map((main) => {
                    if (name === "Hospital Billing" && isApprover && main.viewAccess) {
                        errorMessage("Remove this user from the approver list before changing permissions.");
                        return main;
                    }

                    if (main.title === name) {
                        const updatedMain = {
                            ...main,
                            viewAccess: checked,
                            editAccess: !checked ? false : main.editAccess
                        };

                        updatedMain.main_tabs = main.main_tabs.map((mainTab) => {
                            if (
                                main.title === name &&
                                (main.title !== "Settings" ||
                                    !["User Access", "Sub-Location", "Sub-Location Access", "User Access Configuration", "User Configuration"].includes(mainTab.title))
                            ) {
                                const updatedMainTab = {
                                    ...mainTab,
                                    viewAccess: checked,
                                    editAccess: !checked ? false : mainTab.editAccess
                                };

                                if (updatedMainTab.sub_tabs?.length) {
                                    updatedMainTab.sub_tabs = mainTab.sub_tabs.map((subTab) => ({
                                        ...subTab,
                                        viewAccess: checked,
                                        editAccess: !checked ? false : subTab.editAccess
                                    }));
                                }

                                return updatedMainTab;
                            }
                            return mainTab;
                        });

                        return updatedMain;
                    }

                    return main;
                });

                return { ...user, data: updatedData };
            });
        });
    };

    const onChangeHandleCheckMain = (e) => {
        const { name, checked } = e.target;

        setModuleList((prevModuleList) => {
            return prevModuleList.map((user) => {
                const foundModule = findModuleBySelectedModule(selectedModule);
                if (!foundModule) return user;

                // Use uniqueId for proper isolation of duplicate modules
                if (foundModule.uniqueId && user.uniqueId) {
                    if (user.uniqueId !== foundModule.uniqueId) return user;
                }
                // Fallback to department matching for modules without uniqueId
                else if (foundModule.department && user.department) {
                    if ((user.title !== foundModule.title && user.label !== foundModule.label) || user.department !== foundModule.department) return user;
                }
                // Final fallback to title and module_type matching - ensures proper isolation
                else {
                    const userMatch = user.title || user.label;
                    const foundMatch = foundModule.title || foundModule.label;
                    const userModuleType = user.module_type || user.moduels;
                    const foundModuleType = foundModule.module_type || foundModule.moduels;

                    if (userMatch !== foundMatch || userModuleType !== foundModuleType) return user;
                }

                const updatedData = user.data.map((main) => {
                    const updatedMain = { ...main };

                    updatedMain.main_tabs = main.main_tabs.map((mainTab) => {
                        if ((name === "Cash Counter" || name === "Hospital Billing") && isApprover && mainTab.viewAccess) {
                            errorMessage("Remove this user from the approver list before changing permissions.");
                            return mainTab;
                        } else if (mainTab.title === name && main.viewAccess) {
                            const updatedMainTab = {
                                ...mainTab,
                                viewAccess: checked,
                                editAccess: !checked ? false : mainTab.editAccess
                            };

                            if (updatedMainTab.sub_tabs?.length) {
                                updatedMainTab.sub_tabs = mainTab.sub_tabs.map((subTab) => ({
                                    ...subTab,
                                    viewAccess: checked,
                                    editAccess: !checked ? false : subTab.editAccess
                                }));
                            }

                            return updatedMainTab;
                        }
                        return mainTab;
                    });

                    // Check if all main tabs are unchecked
                    if (updatedMain.main_tabs.every((item) => !item.viewAccess)) {
                        updatedMain.viewAccess = false;
                        updatedMain.editAccess = false;
                    }

                    return updatedMain;
                });

                return { ...user, data: updatedData };
            });
        });
    };

    const onChangeHandleCheckSub = (e) => {
        const { name, checked } = e.target;

        setModuleList((prevModuleList) => {
            return prevModuleList.map((user) => {
                const foundModule = findModuleBySelectedModule(selectedModule);
                if (!foundModule) return user;

                // Use uniqueId for proper isolation of duplicate modules
                if (foundModule.uniqueId && user.uniqueId) {
                    if (user.uniqueId !== foundModule.uniqueId) return user;
                }
                // Fallback to department matching for modules without uniqueId
                else if (foundModule.department && user.department) {
                    if ((user.title !== foundModule.title && user.label !== foundModule.label) || user.department !== foundModule.department) return user;
                }
                // Final fallback to title and module_type matching - ensures proper isolation
                else {
                    const userMatch = user.title || user.label;
                    const foundMatch = foundModule.title || foundModule.label;
                    const userModuleType = user.module_type || user.moduels;
                    const foundModuleType = foundModule.module_type || foundModule.moduels;

                    if (userMatch !== foundMatch || userModuleType !== foundModuleType) return user;
                }

                const updatedData = user.data.map((main) => {
                    const updatedMain = { ...main };

                    updatedMain.main_tabs = main.main_tabs.map((mainTab) => {
                        if (mainTab.sub_tabs?.length) {
                            const updatedMainTab = { ...mainTab };

                            updatedMainTab.sub_tabs = mainTab.sub_tabs.map((subTab) => {
                                if (subTab.title === name && main.viewAccess) {
                                    return {
                                        ...subTab,
                                        viewAccess: checked,
                                        editAccess: !checked ? false : subTab.editAccess
                                    };
                                }
                                return subTab;
                            });

                            if (updatedMainTab.sub_tabs.every((item) => !item.viewAccess)) {
                                updatedMainTab.viewAccess = false;
                                updatedMainTab.editAccess = false;
                            }

                            return updatedMainTab;
                        }
                        return mainTab;
                    });

                    return updatedMain;
                });

                return { ...user, data: updatedData };
            });
        });
    };

    const handleEditAccessChange = (mainItem) => {
        if (
            mainItem?.title === "Hospital Billing" &&
            isApprover &&
            mainItem.viewAccess
        ) {
            errorMessage(
                "Remove this user from the approver list before changing permissions."
            );
            return;
        }

        setModuleList((prevModuleList) => {
            return prevModuleList.map((user) => {
                const foundModule = findModuleBySelectedModule(selectedModule);
                if (!foundModule) return user;

                // Use uniqueId for proper isolation of duplicate modules
                if (foundModule.uniqueId && user.uniqueId) {
                    if (user.uniqueId !== foundModule.uniqueId) return user;
                }
                // Fallback to department matching for modules without uniqueId
                else if (foundModule.department && user.department) {
                    if ((user.title !== foundModule.title && user.label !== foundModule.label) || user.department !== foundModule.department) return user;
                }
                // Final fallback to title and module_type matching - ensures proper isolation
                else {
                    // REQUIRED: Must have exact match on title/label AND module_type
                    const userMatch = user.title || user.label;
                    const foundMatch = foundModule.title || foundModule.label;
                    const userModuleType = user.module_type || user.moduels;
                    const foundModuleType = foundModule.module_type || foundModule.moduels;

                    if (userMatch !== foundMatch || userModuleType !== foundModuleType) return user;
                }

                const updatedData = user.data.map((main) => {
                    if (main.title === mainItem.title) {
                        const updatedMain = {
                            ...main,
                            editAccess: !main.editAccess
                        };

                        updatedMain.main_tabs = main.main_tabs.map((mainTab) => {
                            const updatedMainTab = { ...mainTab };

                            if (!mainTab.viewAccess) {
                                updatedMainTab.editAccess = false;
                            } else if (mainTab.viewAccess) {
                                updatedMainTab.editAccess = updatedMain.editAccess;
                            }

                            if (updatedMainTab.sub_tabs?.length) {
                                updatedMainTab.sub_tabs = mainTab.sub_tabs.map((subTab) => ({
                                    ...subTab,
                                    editAccess: subTab.viewAccess ? updatedMain.editAccess : false
                                }));
                            }

                            return updatedMainTab;
                        });

                        return updatedMain;
                    }
                    return main;
                });

                return { ...user, data: updatedData };
            });
        });
    };

    const handleMainTabEditAccessChange = (mainTabItem, mainItem) => {
        if (
            (mainTabItem.title === "Cash Counter" || mainTabItem.title === "Hospital Billing") &&
            isApprover && mainTabItem.editAccess
        ) {
            errorMessage("Remove this user from the approver list before changing permissions.");
            return;
        }

        setModuleList((prevModuleList) => {
            return prevModuleList.map((user) => {
                const foundModule = findModuleBySelectedModule(selectedModule);
                if (!foundModule) return user;

                // Use uniqueId for proper isolation of duplicate modules
                if (foundModule.uniqueId && user.uniqueId) {
                    if (user.uniqueId !== foundModule.uniqueId) return user;
                }
                // Fallback to department matching for modules without uniqueId
                else if (foundModule.department && user.department) {
                    if ((user.title !== foundModule.title && user.label !== foundModule.label) || user.department !== foundModule.department) return user;
                }
                // Final fallback to title and module_type matching - ensures proper isolation
                else {
                    // REQUIRED: Must have exact match on title/label AND module_type
                    const userMatch = user.title || user.label;
                    const foundMatch = foundModule.title || foundModule.label;
                    const userModuleType = user.module_type || user.moduels;
                    const foundModuleType = foundModule.module_type || foundModule.moduels;

                    if (userMatch !== foundMatch || userModuleType !== foundModuleType) return user;
                }

                const updatedData = user.data.map((main) => {
                    if (main.title === mainItem.title) {
                        const updatedMain = { ...main };

                        updatedMain.main_tabs = main.main_tabs.map((mainTab) => {
                            if (mainTab.title === mainTabItem.title) {
                                const updatedMainTab = {
                                    ...mainTab,
                                    editAccess: !mainTab.editAccess
                                };

                                if (updatedMainTab.sub_tabs?.length) {
                                    updatedMainTab.sub_tabs = mainTab.sub_tabs.map((subTab) => ({
                                        ...subTab,
                                        editAccess: subTab.viewAccess ? updatedMainTab.editAccess : false
                                    }));
                                }

                                return updatedMainTab;
                            }
                            return mainTab;
                        });

                        return updatedMain;
                    }
                    return main;
                });

                return { ...user, data: updatedData };
            });
        });
    };

    const handleSubTabEditAccessChange = (subTabItem, mainTabItem, mainItem) => {
        setModuleList((prevModuleList) => {
            return prevModuleList.map((user) => {
                const foundModule = findModuleBySelectedModule(selectedModule);
                if (!foundModule) return user;

                // Use uniqueId for proper isolation of duplicate modules
                if (foundModule.uniqueId && user.uniqueId) {
                    if (user.uniqueId !== foundModule.uniqueId) return user;
                }
                // Fallback to department matching for modules without uniqueId
                else if (foundModule.department && user.department) {
                    if ((user.title !== foundModule.title && user.label !== foundModule.label) || user.department !== foundModule.department) return user;
                }
                // Final fallback to title and module_type matching - ensures proper isolation
                else {
                    // REQUIRED: Must have exact match on title/label AND module_type
                    const userMatch = user.title || user.label;
                    const foundMatch = foundModule.title || foundModule.label;
                    const userModuleType = user.module_type || user.moduels;
                    const foundModuleType = foundModule.module_type || foundModule.moduels;

                    if (userMatch !== foundMatch || userModuleType !== foundModuleType) return user;
                }

                const updatedData = user.data.map((main) => {
                    if (main.title === mainItem.title) {
                        const updatedMain = { ...main };

                        updatedMain.main_tabs = main.main_tabs.map((mainTab) => {
                            if (mainTab.title === mainTabItem.title) {
                                const updatedMainTab = { ...mainTab };

                                if (updatedMainTab.sub_tabs?.length) {
                                    updatedMainTab.sub_tabs = mainTab.sub_tabs.map((subTab) => {
                                        if (subTab.title === subTabItem.title) {
                                            return {
                                                ...subTab,
                                                editAccess: !subTab.editAccess
                                            };
                                        }
                                        return subTab;
                                    });
                                }

                                return updatedMainTab;
                            }
                            return mainTab;
                        });

                        return updatedMain;
                    }
                    return main;
                });

                return { ...user, data: updatedData };
            });
        });
    };

    const renderModuleList = () => {
        return (
            <>
                <Box component="div" className="eMed_mod_card" style={{ height: "26vw" }}>
                    {(() => {
                        const foundModule = findModuleBySelectedModule(selectedModule);
                        return foundModule ? (
                            <Box key={foundModule.title || foundModule.label}>
                                {foundModule.data?.length > 0
                                    ? foundModule.data.map((i, indMain) => (
                                        <Box sx={{ display: "flex", flexDirection: "column", ml: 4 }} key={indMain}>
                                            <Box display="flex" className="eMed_userAccessRow">
                                                <Box flex={0.7} display="flex" alignItems="center">
                                                    <Box mr={1} position="relative" top="0.2vw">
                                                        <img
                                                            src={i.image ? i.image : ""}
                                                            className="eMed_list_image"
                                                            alt=""
                                                        />
                                                    </Box>
                                                    <FormControlLabel
                                                        label={
                                                            <Typography fontWeight={600} fontSize="1vw">
                                                                {i?.title}
                                                            </Typography>
                                                        }
                                                        value={i?.viewAccess}
                                                        name={i?.title}
                                                        onChange={(e) => onChangeHandleCheck(e)}
                                                        control={
                                                            <Checkbox
                                                                disabled={
                                                                    i?.disable ||
                                                                    (i?.title === "Home" &&
                                                                        (foundModule?.module_type ===
                                                                            "master_record_department" ||
                                                                            foundModule?.module_type === "sub_location")) ||
                                                                    ((foundModule?.module_type === "Pharmacy" ||
                                                                        foundModule?.module_type ===
                                                                        "Standalone Pharmacy") &&
                                                                        i?.title === "Billing")
                                                                }
                                                                checked={i?.viewAccess}
                                                                size="small"
                                                            />
                                                        }
                                                    />
                                                </Box>

                                                <Box
                                                    flex={0.3}
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="flex-end"
                                                    pr="3vw"
                                                >
                                                    {((foundModule?.module_type === "front_office" &&
                                                        i?.title !== "Reports") ||
                                                        (foundModule?.module_type === "Laboratory" &&
                                                            i?.title !== "Reports") ||
                                                        (foundModule?.module_type === "sub_location" &&
                                                            i?.title !== "Reports") ||
                                                        ((foundModule?.module_type === "Pharmacy" ||
                                                            foundModule?.module_type === "Standalone Pharmacy") &&
                                                            i?.title !== "Billing" &&
                                                            i?.title !== "Reports") ||
                                                        ((foundModule?.module_type === "Radiology" ||
                                                            foundModule?.module_type === "Investigation") &&
                                                            i?.title !== "Reports") ||
                                                        (foundModule?.module_type === "store_module" &&
                                                            i?.title !== "Reports" &&
                                                            i?.title !== "Masters") ||
                                                        foundModule?.module_type === "Store Sub Location" ||
                                                        foundModule?.module_type === "master_record_department") && (
                                                            <IconButton
                                                                disabled={!i?.viewAccess}
                                                                onClick={() => handleEditAccessChange(i)}
                                                            >
                                                                <img
                                                                    src={
                                                                        i?.editAccess
                                                                            ? ImagePaths.UserEditOn.default
                                                                            : ImagePaths.UserEditOff.default
                                                                    }
                                                                    className="eMed_list_image"
                                                                />
                                                            </IconButton>
                                                        )}
                                                </Box>
                                            </Box>

                                            {/* MAIN TABS */}
                                            {i?.main_tabs?.length > 0 &&
                                                i.main_tabs.map((tabs, ind) => (
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            ml: 5,
                                                        }}
                                                        key={ind}
                                                    >
                                                        <Box display="flex" className="eMed_userAccessRow">
                                                            <Box flex={0.7}>
                                                                <FormControlLabel
                                                                    label={tabs?.title}
                                                                    value={tabs?.viewAccess}
                                                                    name={tabs?.title}
                                                                    onChange={(e) => onChangeHandleCheckMain(e)}
                                                                    control={
                                                                        <Checkbox
                                                                            disabled={
                                                                                tabs?.disable ||
                                                                                tabs?.title === "OP Appointments" ||
                                                                                (foundModule?.module_type === "Laboratory" &&
                                                                                    tabs?.title === "Create Bill") ||
                                                                                (foundModule?.module_type ===
                                                                                    "sub_location" &&
                                                                                    tabs?.title === "Patient Billing") ||
                                                                                ((foundModule?.module_type === "Radiology" ||
                                                                                    foundModule?.module_type ===
                                                                                    "Investigation") &&
                                                                                    tabs?.title === "Appointments") ||
                                                                                (foundModule?.module_type === "front_office" &&
                                                                                    i?.title === "Settings" &&
                                                                                    (tabs.title ===
                                                                                        "User Access Configuration" ||
                                                                                        tabs.title ===
                                                                                        "User Configuration")) ||
                                                                                ((foundModule?.module_type === "Pharmacy" ||
                                                                                    foundModule?.module_type ===
                                                                                    "Standalone Pharmacy") &&
                                                                                    i?.title === "Settings" &&
                                                                                    (tabs.title === "User Access" ||
                                                                                        tabs.title === "Sub-Location" ||
                                                                                        tabs.title ===
                                                                                        "Sub-Location Access")) ||
                                                                                ((foundModule?.module_type === "Pharmacy" ||
                                                                                    foundModule?.module_type ===
                                                                                    "Standalone Pharmacy") &&
                                                                                    i.title === "Billing" &&
                                                                                    tabs.title === "Billing")
                                                                            }
                                                                            checked={tabs?.viewAccess}
                                                                            size="small"
                                                                        />
                                                                    }
                                                                />
                                                            </Box>

                                                            <Box flex={0.3} display="flex" alignItems="center" pr="3vw" justifyContent="flex-end">
                                                                {((foundModule?.module_type === "front_office" &&
                                                                    i?.title !== "Reports" &&
                                                                    tabs?.title !== "OP Appointments" &&
                                                                    tabs?.title !== "User Access Configuration" &&
                                                                    tabs?.title !== "User Configuration") ||
                                                                    (foundModule?.module_type === "Laboratory" &&
                                                                        tabs?.title !== "Create Bill" &&
                                                                        i?.title !== "Reports") ||
                                                                    (foundModule?.module_type === "sub_location" &&
                                                                        i?.title !== "Reports") ||
                                                                    ((foundModule?.module_type === "Pharmacy" ||
                                                                        foundModule?.module_type ===
                                                                        "Standalone Pharmacy") &&
                                                                        i?.title !== "Reports" &&
                                                                        tabs.title !== "User Access" &&
                                                                        tabs.title !== "Sub-Location" &&
                                                                        tabs.title !== "Sub-Location Access") ||
                                                                    ((foundModule?.module_type === "Radiology" ||
                                                                        foundModule?.module_type === "Investigation") &&
                                                                        tabs?.title !== "Create Bill" &&
                                                                        i?.title !== "Reports" &&
                                                                        tabs?.title !== "Appointments") ||
                                                                    (foundModule?.module_type === "store_module" &&
                                                                        i?.title !== "Reports" &&
                                                                        i?.title !== "Masters") ||
                                                                    foundModule?.module_type === "Store Sub Location" ||
                                                                    foundModule?.module_type ===
                                                                    "master_record_department") && (
                                                                        <IconButton
                                                                            disabled={!tabs?.viewAccess}
                                                                            onClick={() => handleMainTabEditAccessChange(tabs, i)}
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    tabs?.editAccess
                                                                                        ? ImagePaths.UserEditOn.default
                                                                                        : ImagePaths.UserEditOff.default
                                                                                }
                                                                                className="eMed_list_image"
                                                                            />
                                                                        </IconButton>
                                                                    )}
                                                            </Box>
                                                        </Box>

                                                        {/* SUB-TABS */}
                                                        {tabs?.sub_tabs?.length > 0 &&
                                                            tabs?.sub_tabs?.map((subTabs, index) => (
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        ml: 5,
                                                                    }}
                                                                    key={index}
                                                                >
                                                                    <Box
                                                                        display="flex"
                                                                        className="eMed_userAccessRow"
                                                                    >
                                                                        <Box flex={0.7}>
                                                                            <FormControlLabel
                                                                                label={subTabs?.title}
                                                                                value={subTabs?.viewAccess}
                                                                                name={subTabs?.title}
                                                                                onChange={(e) =>
                                                                                    onChangeHandleCheckSub(e)
                                                                                }
                                                                                control={
                                                                                    <Checkbox
                                                                                        disabled={
                                                                                            subTabs?.disable ||
                                                                                            (foundModule?.module_type ===
                                                                                                "front_office" &&
                                                                                                i?.title === "Settings" &&
                                                                                                ((tabs.title ===
                                                                                                    "User Access Configuration" &&
                                                                                                    subTabs.title ===
                                                                                                    "User Access") ||
                                                                                                    (tabs.title ===
                                                                                                        "User Configuration" &&
                                                                                                        subTabs.title ===
                                                                                                        "User Configuration")))
                                                                                        }
                                                                                        checked={subTabs?.viewAccess}
                                                                                        size="small"
                                                                                    />
                                                                                }
                                                                            />
                                                                        </Box>

                                                                        <Box
                                                                            flex={0.3}
                                                                            display="flex"
                                                                            alignItems="center"
                                                                            pr="3vw"
                                                                            justifyContent="flex-end"
                                                                        >
                                                                            {((tabs?.title === "Financial Reports" &&
                                                                                subTabs?.title === "Expenses") ||
                                                                                (i?.title !== "Reports" &&
                                                                                    tabs?.title !==
                                                                                    "User Access Configuration" &&
                                                                                    tabs?.title !==
                                                                                    "User Configuration")) && (
                                                                                    <IconButton
                                                                                        disabled={!subTabs?.viewAccess}
                                                                                        onClick={() => handleSubTabEditAccessChange(subTabs, tabs, i)}
                                                                                    >
                                                                                        <img
                                                                                            src={
                                                                                                subTabs?.editAccess
                                                                                                    ? ImagePaths.UserEditOn.default
                                                                                                    : ImagePaths.UserEditOff.default
                                                                                            }
                                                                                            className="eMed_list_image"
                                                                                        />
                                                                                    </IconButton>
                                                                                )}
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                            ))}
                                                    </Box>
                                                ))}
                                        </Box>
                                    ))
                                    : null}
                            </Box>
                        ) : null;
                    })()}
                </Box>
            </>
        );
    };


    const moduleAccessTab = () => {
        return (
            <Box component="div">
                <Box component="div" className="eMed_left_header">
                    <FormControl size="small" className="eMed_select_text_box_ui">
                        <InputLabel>{"Module"}</InputLabel>
                        <Select
                            disabled={moduleAndRoleList?.length === 0}
                            label={"Module"}
                            value={selectedModule}
                            name="selectedModule"
                            onChange={(e) => onChangeHandler(e)}
                        >
                            {moduleAndRoleList?.length > 0
                                ? moduleAndRoleList
                                    .filter((item) => {
                                        // Allow all modules - just display them differently based on department
                                        return true;
                                    })
                                    .map((item, idx) => {
                                        // For Store Sub Location and sub_location modules, show department suffix if available
                                        let displayName = item?.module_name;

                                        // Only add department suffix if the module_name doesn't already have it
                                        // and department is not null/undefined
                                        if ((item?.moduels === "Store Sub Location" || item?.moduels === "sub_location") &&
                                            item?.department &&
                                            item?.department !== null &&
                                            item?.department !== undefined &&
                                            !item?.module_name.includes("(") &&
                                            !item?.module_name.includes(")")) {
                                            displayName = `${item?.module_name} (${item?.department})`;
                                        }

                                        // Create unique value by combining module_name, moduels, and optionally id
                                        // This ensures modules with same name but different types are distinct
                                        let uniqueValue = `${item?.module_name}::${item?.moduels}`;
                                        if (item?.department) {
                                            uniqueValue += `::${item?.department}`;
                                        }
                                        // Use id as fallback for uniqueness if needed
                                        const uniqueKey = item?.id ? `${item?.module_name}_${item?.moduels}_${item?.id}_${idx}` : `${item?.module_name}_${item?.moduels}_${idx}`;

                                        return (
                                            <MenuItem key={uniqueKey} value={uniqueValue}>
                                                {displayName}
                                            </MenuItem>
                                        );
                                    })
                                : null}
                        </Select>
                    </FormControl>
                </Box>

                {(selectedModule !== "" && selectedModule !== null) ? (
                    <Box component="div">{renderModuleList()}</Box>
                ) : (
                    <Box component="div">
                        <Box component="div" className="eMed_new_user_img">
                            <img src={ImagePaths.NewUserImg.default} alt="new User" />
                        </Box>
                        <Box component="div" className="eMed_new_user">
                            <Typography component="div" fontWeight={600}> Select any module to continue</Typography>
                            <Typography component="div" fontWeight={400} fontSize="0.8vw" color="#616161">
                                Kindly Add any module to edit user access
                            </Typography>
                        </Box>
                    </Box>
                )}
            </Box>
        );
    };

    const handleCheckBox = (e, type, billtype) => {
        const checked = e.target.checked;

        setStates(prev => {
            const updated = { ...prev };
            updated.per_Access[type][billtype] = checked;
            if (billtype === "cash_counter" && !checked) {
                updated.per_Access.cash_counter_modules = [];
                updated.per_Access.show_cash_counter_for = [];
            }

            return updated;
        });

        setStates(prev => {
            if (billtype === 'show_order_amounts' && !checked) {
                return {
                    ...prev,
                    per_Access: {
                        ...prev.per_Access,
                        common: {
                            ...prev.per_Access.common,
                            edit_order_amounts: false
                        }
                    }
                };
            }
            return prev;
        });
    };

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value.trimStart();
        const isValid = CommonValidation.numberOnly(value);

        setStates(prev => {
            const updated = { ...prev };

            switch (name) {
                case "opEditDay":
                    if (prev.opEditDur && (isValid && (prev.opEditDur === 1 ? value <= 45 : value <= 24 || value === ""))) {
                        updated["opEditDay"] = +value;
                    }
                    break;

                case "ipEditDay":
                    if (prev.ipEditDur && (isValid && (prev.ipEditDur === 1 ? value <= 45 : value <= 24 || value === ""))) {
                        updated["ipEditDay"] = +value;
                    }
                    break;

                case "labEditDay":
                    if (prev.labEditDur && (isValid && (prev.labEditDur === 1 ? value <= 45 : value <= 24 || value === ""))) {
                        updated["labEditDay"] = +value;
                    }
                    break;

                case "pharmaEditDay":
                    if (prev.pharmaEditDur && (isValid && (prev.pharmaEditDur === 1 ? value <= 45 : value <= 24 || value === ""))) {
                        updated["pharmaEditDay"] = +value;
                    }
                    break;

                default:
                    break;
            }

            return updated;
        });
    };


    const renderPermissionList = (billtype, type, isday, label, value, statekey1, value1, statekey2, value2, subTxt, isViewRpt = false) => {
        const duration = [
            { label: "Day(s)", value: 1 },
            { label: "Hour(s)", value: 2 }
        ];

        const DateFilterList = [
            { label: "Last 7 Days", value: "last7days" },
            { label: "Last 30 Days", value: "last30days" },
        ];

        return (
            <Stack direction="row" justifyContent="space-Between" alignItems="center" sx={{ height: "4.5vw" }}>
                <Stack direction="column" justifyContent={"center"}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                disabled={billtype === "edit_order_amounts" && !states?.per_Access?.common?.show_order_amounts}
                                checked={value}
                                onChange={(e) => handleCheckBox(e, type, billtype)}
                            />
                        }
                        label={<Typography id="eMed_permission_checkTxt"> {(label)} </Typography>}
                    />
                    <Typography id="eMed_permission_Txt">
                        {isday ? "User can able to reverse or modify the bills" : subTxt ? `${(subTxt)}` : 'User can able to create credit bills'}
                    </Typography>
                </Stack>

                {isday ? (
                    <Stack direction="column" justifyContent={"center"} mt={1.5}>
                        <Typography id="eMed_permission_TimeTxt">{"Time Limit From Bill Date"}</Typography>
                        <Stack direction={"row"}>
                            <TextField
                                sx={{ width: "6vw", fontSize: "0.9vw" }}
                                size='small'
                                autoComplete="off"
                                className='eMed_temp_txt'
                                name={statekey1}
                                value={value1 || ""}
                                onChange={(e) => handleChange(e)}
                                inputProps={{ style: { textAlign: 'center' } }}
                            />
                            <FormControl sx={{ width: "6.3vw", backgroundColor: Colors.Background }} size="small">
                                <Select
                                    value={value2 || ""}
                                    name={statekey2}
                                    onChange={(event) => {
                                        setStates(prev => ({ ...prev, [statekey2]: event.target.value }));
                                    }}
                                    sx={{ fontSize: "0.9vw" }}
                                >
                                    {duration.map((list, index) => (
                                        <MenuItem key={index} value={list.value} sx={{ fontSize: "0.8vw" }}>
                                            {list.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Stack>
                    </Stack>
                ) : isViewRpt ? (
                    <Select
                        className="eMed_pharma_settings_option_action"
                        emed_tid={`usr_${billtype}`}
                        sx={{ width: '9vw', marginRight: '1vw', fontSize: "0.95vw" }}
                        size='small'
                        value={value}
                        onChange={(e) => {
                            setStates(prev => ({
                                ...prev,
                                per_Access: {
                                    ...prev.per_Access,
                                    pharma: { ...prev.per_Access.pharma, isViewRpt: e.target.value }
                                }
                            }));
                        }}
                    >
                        {DateFilterList.map((item, index) => (
                            <MenuItem key={index} value={item.value} sx={{ fontSize: "0.95vw" }} emed_tid={`usr_${item.value}`}>
                                {item.label}
                            </MenuItem>
                        ))}
                    </Select>
                ) : billtype === "cash_counter" ? (
                    <Select
                        className="eMed_pharma_settings_option_action"
                        emed_tid={`usr_${billtype}`}
                        sx={{ width: '20vw', marginRight: '1vw', fontSize: "0.95vw" }}
                        size='small'
                        disabled={!states?.per_Access?.common?.cash_counter}
                        value={states?.per_Access?.cash_counter_modules}
                        multiple={true}
                        onChange={(e) => {
                            setStates(prev => ({
                                ...prev,
                                per_Access: { ...prev.per_Access, cash_counter_modules: e.target.value }
                            }));
                        }}
                    >
                        {cashCounterModuleList?.map((item, index) => (
                            <MenuItem key={index} value={item} sx={{ fontSize: "0.95vw" }} emed_tid={`usr_${item}_cash_counter`}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                ) : null}
            </Stack>
        );
    };

    const permissionTab = () => {
        return (
            <Box>
                <Box component={'div'} className='eMed_permission_box'>
                    <Box component={'div'} className='eMed_permission_hdrBox'>
                        <Typography id='eMed_permission_header' mb={1}>{"Permission"}</Typography>
                        <Typography id='eMed_permission_subheader'>{"Select permission to grant"}</Typography>
                    </Box>
                    <Box component={'div'} className='eMed_permission_card' style={{ height: "25vw" }}>
                        {!isFromPharmacy && (
                            <>
                                {renderPermissionList('is_credit', 'op', false, "OP Credit Bills", states?.per_Access?.op?.is_credit)}
                                {renderPermissionList('is_credit', 'ip', false, "IP Credit Bills", states?.per_Access?.ip?.is_credit)}
                                {renderPermissionList('is_credit', 'lab', false, "Lab Credit Bills", states?.per_Access?.lab?.is_credit)}
                                {renderPermissionList('modify_credit_bill', 'common', false, "User can modify the Credit bills ?", states?.per_Access?.common?.modify_credit_bill, "", "", "", "", "User can modify the OP, IP, Lab Credit bills ?")}
                                {renderPermissionList('cancel_bill_approval', 'common', false, "Cancel access permission", states?.per_Access?.common?.cancel_bill_approval, "", "", "", "", "User can able to cancel bills")}
                                {renderPermissionList('is_pov_editable', 'op', false, "Can user edit purpose of visit after appointment", states?.per_Access?.op?.is_pov_editable, "", "", "", "", "User can edit purpose of visit")}
                                {renderPermissionList('is_demographics_edit', 'common', false, "Restrict user from editing name and gender", states?.per_Access?.common?.is_demographics_edit, "", "", "", "", "Restrict user from editing name and gender")}
                                {localGetItem("enable_safety_deposit") === "true" && renderPermissionList('safety_deposit_permission', 'common', false, "Can user use Safety Deposit", states?.per_Access?.common?.safety_deposit_permission, "", "", "", "", "User can access safety deposit")}
                                {renderPermissionList('can_view_dashboard', 'common', false, "Permission granted to view dashboard", states?.per_Access?.common?.can_view_dashboard, "", "", "", "", "User can able to view dashboard")}
                            </>
                        )}
                        {renderPermissionList('is_credit', 'pharma', false, "Pharmacy Credit Bills", states?.per_Access?.pharma?.is_credit)}
                        {renderPermissionList('isShowPo', 'pharma', false, "Show Direct Po Button", states?.per_Access?.pharma?.isShowPo, "", "", "", "", "User is able to add direct Po")}
                        {renderPermissionList('isDiscountEdit', 'pharma', false, "Discount % Editable access", states?.per_Access?.pharma?.isDiscountEdit, "", "", "", "", "User can change the pharmacy discount percentage")}
                        {renderPermissionList('isViewRpt', 'pharma', false, "Can User View Reports and Invoices Upto", states?.per_Access?.pharma?.isViewRpt, "", "", "", "", "User can view the reports and invoice", true)}
                        {renderPermissionList('isEditSave', 'pharma', false, "Can User Edit & Delete the Saved Bills", states?.per_Access?.pharma?.isEditSave, "", "", "", "", "User can able to reverse or modify the bills")}
                        {renderPermissionList('isCrtDrug', 'pharma', false, "Can User Create New Drugs", states?.per_Access?.pharma?.isCrtDrug, "", "", "", "", "User can create new drugs")}
                        {isFromPharmacy && loggedInUserInfo?.pharmacy_type === 'Inhouse Pharmacy' && renderPermissionList('isApprover', 'pharma', false, "Indent Approver", states?.per_Access?.pharma?.isApprover, "", "", "", "", "Approver for intent request")}
                        {renderPermissionList('isViewMargin', 'pharma', false, "Can User View Margin Profit", states?.per_Access?.pharma?.isViewMargin, "", "", "", "", "User can view margin profit")}
                        {renderPermissionList('change_payment_mode', 'common', false, "Can User Change the Payment Mode", states?.per_Access?.common?.change_payment_mode, "", "", "", "", "User can change the Payment Mode of any receipts")}
                        {renderPermissionList('isReturnBill', 'pharma', false, "Can User allow Retrun Bill", states?.per_Access?.pharma?.isReturnBill, "", "", "", "", "User can Return the Bill")}
                        {isFromPharmacy && loggedInUserInfo?.pharmacy_type === 'Inhouse Pharmacy' && renderPermissionList('isGRNEntry', 'pharma', false, "Can User allow  GRN Edit Access", states?.per_Access?.pharma?.isGRNEntry, "", "", "", "", "User can allow  GRN Edit access")}
                        {renderPermissionList('isPOrequestApprove', 'pharma', false, "Can User Approve or Reject the PO Request", states?.per_Access?.pharma?.isPOrequestApprove, "", "", "", "", "Can User Approve or Reject the PO Request")}
                        {localGetItem('isNewBilling') !== "false" && renderPermissionList('cash_counter', 'common', false, "Can a user receive cash from the cash counter ?", states?.per_Access?.common?.cash_counter, "", "", "", "", "Select module-wise access for the cash counter.", false)}
                        {(!isFromPharmacy && localGetItem('isNewBilling') !== "false") && renderPermissionList('show_order_amounts', 'common', false, "Can a user see the amount details of orders?", states?.per_Access?.common?.show_order_amounts, "", "", "", "", "Isn't a user allowed to see the amount details of orders", false)}
                        {(isFromPharmacy && localGetItem('isNewBilling') === "true") && renderPermissionList('isReceivePayment', 'pharma', false, "Allow user to access the Receive Payment button", states?.per_Access?.pharma?.isReceivePayment, "", "", "", "", "User allowed to access the Receive Payment button")}
                        {(!isFromPharmacy && localGetItem('isNewBilling') !== "false") && renderPermissionList('edit_order_amounts', 'common', false, "Can a user edit the amount details of orders?", states?.per_Access?.common?.edit_order_amounts, "", "", "", "", "Isn't a user allowed to edit the amount details of orders", false)}
                        {localGetItem('isNewBilling') !== "false" && renderPermissionList('allow_concession', 'common', false, "User can give concession to bills", states?.per_Access?.common?.allow_concession, "", "", "", "", "Users can grant concessions on bills")}
                        {localGetItem('isNewBilling') !== "false" && renderPermissionList('allow_final_bill', 'common', false, "User can generate final bill", states?.per_Access?.common?.allow_final_bill, "", "", "", "", "Users can initiate final bills")}
                    </Box>
                </Box>
            </Box>
        );
    };


    return (
        <Box sx={{ padding: "3px", backgroundColor: "white", height: "80vh", display: "flex", flexDirection: "column" }}>
            <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray' }}>
                <IconButton onClick={() => history.push("/Settings/UserAccess/UserSettings/GlobalRoleMaster")}>
                    <ChevronLeftIcon color='primary' />
                </IconButton>
                <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{id ? "Edit Role" : "Add Role"}</Typography>
            </Box>

            <Grid container spacing={4} sx={{ flex: 1 }}>
                <Grid item xs={12} md={4}>
                    <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 1, p: 2, height: "100%" }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
                            Role Details
                        </Typography>
                        <TextField fullWidth disabled label="Role Code" name="role_code" value={role.role_code} onChange={handleRoleDetailsChange} sx={{ mb: 2 }} />
                        <TextField inputProps={{ maxLength: 100 }} fullWidth label="Role Name*" name="role_name" value={role.role_name} onChange={handleRoleDetailsChange} sx={{ mb: 2 }} />
                        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                            Module Access
                        </Typography>
                        <Box sx={{ height: "37vh", overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: 1, p: 1 }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                {userModuleData.map((item, index) => {
                                    const isChecked = moduleAndRoleList?.find((list) => {
                                        if (item?.module === "Pharmacy" && item.pharmacy_name === list?.module_name && list?.moduels === item?.module) {
                                            return true;
                                        } else if (item?.module === "Laboratory" && item.laboratory_name === list?.module_name && list?.moduels === item?.module) {
                                            return true;
                                        } else if (item?.module === "front_office" && item.clinic_name === list?.module_name && list?.moduels === item?.module) {
                                            return true;
                                        } else if (item?.module === "Radiology" && item.radiology_name === list?.module_name && list?.moduels === item?.module) {
                                            return true;
                                        } else if (item?.module === "store_module" && item.store_name === list?.module_name && list?.moduels === item?.module) {
                                            return true;
                                        } else if (item?.module === "Store Sub Location" && ((item.sublocation_name === list?.module_name) || (item.sublocation_name + " (" + item.department + ")" === list?.module_name)) && list?.moduels === item?.module) {
                                            return true;
                                        } else if (item?.module === "Investigation" && item.investigation_name === list?.module_name && list?.moduels === item?.module) {
                                            return true;
                                        } else if (item?.module === "master_record_department" && item.mrd_name === list?.module_name && list?.moduels === item?.module) {
                                            return true;
                                        } else if (item?.module === "sub_location" && item.sublocation_name === list?.module_name && list?.moduels === item?.module) {
                                            return true;
                                        }
                                        return false;
                                    });

                                    let label = item?.module;
                                    if (item?.module === "front_office") label = item?.clinic_name;
                                    if (item?.module === "Radiology") label = item?.radiology_name;
                                    if (item?.module === "Laboratory") label = item?.laboratory_name;
                                    if (item?.module === "Pharmacy") label = item?.pharmacy_name;
                                    if (item?.module === "Investigation") label = item?.investigation_name;
                                    if (item?.module === "store_module") label = item?.store_name;
                                    if (item?.module === "Store Sub Location") label = item?.sublocation_name + " (" + item.department + ")";
                                    if (item?.module === "master_record_department") label = item?.mrd_name;
                                    if (item?.module === "sub_location") label = item?.sublocation_name;

                                    return (
                                        <FormGroup key={index}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={isChecked !== undefined}
                                                        disabled={disableCondition(item)}
                                                        onChange={() => {
                                                            let line_index = null;
                                                            const isItemInArray = moduleAndRoleList?.find((selectedItem, i) => {
                                                                if (
                                                                    (selectedItem.module_name === item.laboratory_name && selectedItem.moduels === item.module) ||
                                                                    (selectedItem.module_name === item.pharmacy_name && selectedItem.moduels === item.module) ||
                                                                    (selectedItem.module_name === item.clinic_name && selectedItem.moduels === item.module) ||
                                                                    (((selectedItem.module_name === item.sublocation_name) || (selectedItem.module_name === item.sublocation_name + " (" + item.department + ")")) && selectedItem.moduels === item.module) ||
                                                                    (selectedItem.module_name === item.store_name && selectedItem.moduels === item.module) ||
                                                                    (selectedItem.module_name === item.module_name && selectedItem.moduels === item.module) ||
                                                                    (selectedItem.module_name === item.investigation_name && selectedItem.moduels === item.module) ||
                                                                    (selectedItem.module_name === item.mrd_name && selectedItem.moduels === item.module) ||
                                                                    (selectedItem.module_name === item.radiology_name && selectedItem.moduels === item.module)
                                                                ) {
                                                                    line_index = i;
                                                                    return true;
                                                                }
                                                                return false;
                                                            });

                                                            if (isItemInArray) {
                                                                setModuleAndRoleList((prev) =>
                                                                    prev.filter((_, i) => i !== line_index)
                                                                );
                                                                setShouldRunSubLocation(true);
                                                            } else {
                                                                let module = {
                                                                    module_name: "",
                                                                    moduels: "",
                                                                    id: null,
                                                                    label: "",
                                                                };
                                                                let moduleName = "";
                                                                let module_id = null;

                                                                if (item?.clinic_id) {
                                                                    moduleName = item?.clinic_name;
                                                                    module_id = item?.clinic_id;
                                                                } else if (item?.laboratory_id) {
                                                                    moduleName = item?.laboratory_name;
                                                                    module_id = item?.laboratory_id;
                                                                } else if (item?.pharmacy_id) {
                                                                    moduleName = item?.pharmacy_name;
                                                                    module_id = item?.pharmacy_id;
                                                                } else if (item?.id && (item?.radiology_name || item?.investigation_name)) {
                                                                    moduleName = item?.radiology_name
                                                                        ? item?.radiology_name
                                                                        : item?.investigation_name;
                                                                    module_id = item?.id;
                                                                } else if (item?.id && item?.store_name) {
                                                                    moduleName = item?.store_name;
                                                                    module_id = item?.id;
                                                                } else if (item?.id && item?.sublocation_name) {
                                                                    moduleName = item?.sublocation_name + (item.department ? " (" + item.department + ")" : "");
                                                                    module_id = item?.id;
                                                                } else if (item?.id && item?.mrd_name) {
                                                                    moduleName = item?.mrd_name;
                                                                    module_id = item?.id;
                                                                }

                                                                module = {
                                                                    module_name: moduleName,
                                                                    moduels: item?.module,
                                                                    id: module_id,
                                                                    label: moduleName,
                                                                };

                                                                if (item?.id && item?.sublocation_name) {
                                                                    module["department"] = item?.department;
                                                                }
                                                                setModuleAndRoleList((prev) => [...prev, module]);
                                                                setShouldRunSubLocation(true);
                                                            }
                                                        }}
                                                    />
                                                }
                                                label={label}
                                            />
                                        </FormGroup>
                                    );
                                })}
                            </Box>
                        </Box>
                    </Box>
                </Grid>

                <Grid item xs={12} md={8}>
                    <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 1, height: "33.5vw", overflowY: "auto" }}>
                        <Tabs
                            value={tabDetail}
                            onChange={(e, newValue) => setTabDetail(newValue)}
                        >
                            <Tab value="one" label={"Module Access"} className="eMed_tab_header" />
                            <Tab value="two" label={"Permissions"} className="eMed_tab_header" />
                        </Tabs>
                        {tabDetail === "one" ? moduleAccessTab() : tabDetail === "two" ? permissionTab() : null}
                    </Box>
                </Grid>
            </Grid>

            {message.isErrorMsg && (
                <ToastMsg
                    severity="error"
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
            )}
            {message.successMsg && (
                <ToastMsg
                    severity="success"
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
            )}

            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
                <Button size="small" sx={{ textTransform: 'capitalize', marginRight: "1dvw" }} variant="contained"
                    onClick={() => {
                        const ModulesList = localGetItem("ModulesList") ? JSON.parse(localGetItem("ModulesList")) : [];
                        const branchId = localGetItem("BranchId") ? +localGetItem("BranchId") : null;
                        const module = ModulesList?.find((list) => list?.branch_id === branchId);
                        const ModuleData = module?.data?.find((list) => (list?.moduels === "Radiotherapy")) || null;
                        let AccessList = JSON.parse(JSON.stringify(NEW_MODULE_LIST_DATA));
                        AccessList[0].title = ModuleData?.label;

                        setRole({ ...role, module_access: AccessList });

                        setStates(prev => ({ ...prev, per_Access: structuredClone(Permission_Access) }));

                        // Reset moduleList using the extracted function
                        const filteredModule = initializeModuleList();
                        if (filteredModule.length > 0) {
                            setModuleList(filteredModule);
                        }

                        // Clear selected module and module list
                        setSelectedModule("");
                        setModuleAndRoleList([]);
                    }}>
                    {"Reset"}
                </Button>
                <Button size="small" sx={{ textTransform: 'capitalize' }} variant="contained" onClick={() => {
                    let isValidAccess = false;
                    if (role?.module_access && role.module_access.length > 0) {
                        isValidAccess = role.module_access.some((module) => {
                            // For new roles: module has {title, module_type, data}
                            if (module.data && Array.isArray(module.data)) {
                                return module.data.some((item) => item?.viewAccess);
                            }
                            // For edit roles: module has {module_access: [{data}]}
                            else if (Array.isArray(module.module_access) && module.module_access.length > 0) {
                                return module.module_access.some((moduleAccess) => 
                                    moduleAccess?.data?.some((item) => item?.viewAccess)
                                );
                            }
                            return false;
                        });
                    }
                    if (isValidAccess && role?.role_name) {
                        handleSave()
                    } else if (!role?.role_name) {
                        errorMessage("Enter Role name");
                    } else {
                        errorMessage("Give access for atleast any one screen");
                    }
                }}>
                    {role.edit_id ? "Update Role" : "Add Role"}
                </Button>
            </Box>
            <Loader loaderOpen={isloader} />
        </Box>
    );
};

export default AddGlobalRole;